














































import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {DownloadPackageApi, ImageDto} from "@swagger";
import {Prop, Watch} from "vue-property-decorator";

@Component({})
export default class ImageDownload extends BasicComponent {

  @Prop(String) code: string;

  images: ImageDto[] = [];

  created() {
    this.requestImages();
  }

  requestImages() {
    if (this.code == null) return;
    new DownloadPackageApi(this.apiConfiguration).listImages(this.code)
        .then((data: Array<ImageDto>) => {
          this.images = data;
        })
        .catch((err) => {
          console.error(err);
        });
  }

  @Watch("code")
  onCodeChanged(newVal, oldVal) {
    this.requestImages();
  }

}

